<h2 mat-dialog-title>Export invoices — {{ data.clientName }}</h2>

<form [formGroup]="form" (ngSubmit)="submit()">
  <mat-dialog-content>
    <section class="scopes">
      <h3>Include</h3>
      <p class="hint">Select one or more attachment scopes.</p>
      <mat-checkbox *ngFor="let opt of scopeOptions" [formControlName]="scopeControlName(opt.value)">
        {{ opt.label }}
      </mat-checkbox>
      <mat-error *ngIf="form.touched && form.errors?.scopeRequired">
        Pick at least one scope.
      </mat-error>
    </section>

    <section class="filters">
      <mat-form-field appearance="fill">
        <mat-label>Date field</mat-label>
        <mat-select formControlName="date_field">
          <mat-option *ngFor="let opt of dateFieldOptions" [value]="opt.value">
            {{ opt.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>From</mat-label>
        <input matInput [matDatepicker]="fromPicker" formControlName="from" />
        <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
        <mat-error *ngIf="form.get('from')?.touched && form.get('from')?.hasError('required')">
          From is required.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>To</mat-label>
        <input matInput [matDatepicker]="toPicker" formControlName="to" />
        <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
        <mat-datepicker #toPicker></mat-datepicker>
        <mat-error *ngIf="form.get('to')?.touched && form.get('to')?.hasError('required')">
          To is required.
        </mat-error>
      </mat-form-field>

      <mat-error *ngIf="form.touched && form.errors?.dateRange" class="range-error">
        From must be on or before To.
      </mat-error>
    </section>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">
      Start export
    </button>
  </mat-dialog-actions>
</form>
